module.exports = __webpack_public_path__ + "static/media/trial3_1.68199bca.png";